export const getLanguageOptions = (ticketSeriesType: string): string[] => {
  switch (ticketSeriesType) {
    case "CH_PARKING":
    case "CH_PARKING_VIOLATION_ZPO":
    case "CH_PARKING_VIOLATION_NON_ZPO":
    case "CH_DRIVE_OFF":
      return ["DE", "FR", "IT"];

    case "AT_DRIVE_OFF":
    case "AT_PARKING_VIOLATION_ZPO":
      return ["DE"];

    case "DE_DRIVE_OFF":
    case "DE_PARKING_VIOLATION_NON_ZPO":
      return ["DE"];

    default:
      return ["DE", "FR", "IT"];
  }
};
